// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"282":"40e6ee6e","364":"a10acc94","437":"44825e28","724":"0b94b40c","748":"4ce3cafd","758":"083f1269"}[chunkId] + ".chunk.css";
};